import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import queryString from 'query-string';

import {helper, http, route, api} from './common/common'
import FormPaper from './common/FormPaper';

const styles = (theme) => {
    return {
        root: {
            width: 450,
            height: 500,
        },
        text: {
            marginTop: 32,
        },
        controlGroup: {
            position: 'absolute',
            width: '100%',
            right: 0,
            bottom: 0,
            margin: 0,
        },
        control: {
            float: 'right',
            marginRight: 0,
            marginLeft: 16,
        }
    };
}

class OrganizationJoin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tag: '',
        };

        const params = helper.sanitizeDict(
            queryString.parse(this.props.location.search), 'code');

        this._code = params['code'];
        this._cancelToken = http.CancelToken.source();
        this._redirectToken = null;
        this._organizationName = '';

        this._requestJoin();
    }

    componentWillUnmount = () => {
        if (this._redirectToken) {
            this._redirectToken.cancel();
        }

        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        if (this.state.tag === '') {
            return null;
        }
        else if (this.state.tag === 'success') {
            return this._renderSuccess();
        } else {
            return this._renderFailure();
        }
    }

    _renderSuccess = () => {
        const {classes} = this.props;

        return (
            <FormPaper
                className={classes.root}
                heading='Successfully'
                subHeading='invited as a new member'
            >
                <Typography
                    className={classes.text}
                    align='justify'
                    gutterBottom={true}
                >
                    You have successfully join the organization
                </Typography>
                <Typography
                    className={classes.text}
                    align='center'
                    variant='subtitle1'
                    gutterBottom={true}
                >
                    {this._organizationName}
                </Typography>
                <Typography
                    className={classes.text}
                    align='justify'
                    gutterBottom={true}
                >
                    as a new member. You will be redirected back to the home page shortly.
                </Typography>
                <div className={classes.controlGroup}>
                    <Button
                        className={classes.control}
                        id='back'
                        color='secondary'
                        variant = 'raised'
                        onClick={this._handleContinue}
                    >
                        Continue
                    </Button>
                </div>
            </FormPaper>
        );
    }

    _renderFailure = () => {
        const {classes} = this.props;

        return (
            <FormPaper
                className={classes.root}
                heading='Oops'
                subHeading='an error as occurred'
            >
                <Typography
                    className={classes.text}
                    align='justify'
                    gutterBottom={true}
                >
                    {this._getErrorText()}
                    <br/>
                    <br/>
                    Please request a new invitation link from the owner.
                </Typography>
                <div className={classes.controlGroup}>
                    <Button
                        className={classes.control}
                        id='back'
                        color='secondary'
                        variant='contained'
                        onClick={this._handleBack}
                    >
                        Back
                    </Button>
                </div>
            </FormPaper>
        );
    }

    _getErrorText = () => {
        switch (this.state.tag) {
            case 'invalid_client':
                return 'Your invitation link has expired. For security reasons the link is only valid for 7 days.';
            case 'invalid_match':
                return 'The username attached to the invitation link was different from the username used to sign in.';
            default:
                return 'The invitation link is invalid. For security reasons the process will not continue.';
        }
    }

    _handleContinue = () => {
        route(this, '/home', '');
    }

    _handleBack = () => {
        this.props.setAccessCode('');
        route(this, '/home', '');
    }

    _requestJoin = async () => {
        try {
            const response = await http.post(api.invite() + '/accept', {
                'access_code': this.props.getAccessCode(),
                'code': this._code,
            }, {
                cancelToken: this._cancelToken.token,
            });

            this._organizationName = response.data.organization_name;

            route(this, '/home', '', {}, 10000, this._redirectToken);

            this.setState({
                tag: 'success',
            });
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._organizationName = '';

            this.setState({
                tag: (error.response.data.error) ? error.response.data.error : 'failed',
            });
        }
    }
}

OrganizationJoin.propTypes = {
    setError: PropTypes.func.isRequired,
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
}

export default withStyles(styles)(OrganizationJoin);
